<template>
  <div :class="[renderAsRow ? 'wc-row' : '', 'img-element']">
    <div :class="[renderAsRow ? 'wc-col' : '', 'img-element__inner']">
      <img
        v-if="breakpoints && breakpoints.length > 0"
        :srcset="getSrcset()"
        :src="getSrc('xl')"
        :sizes="getSizes()"
        alt=""
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  imagePath: { type: String },
  imageName: { type: String },
  breakpoints: { type: Array<number> },
  renderAsRow: { type: Boolean }
})
const assetsBaseUrl = globalThis.ENV_CONFIG?.ASSETS_BASE_URL.CUSTOMER_PORTAL || ''

const getSrc = (size: string) => {
  return `${assetsBaseUrl}/${props.imagePath}/${props.imageName}_${size}.png`
}
const getSrcset = () => {
  if (props.breakpoints && props.breakpoints.length > 0) {
    return `${getSrc('xs')} ${props.breakpoints[0]}w,
            ${getSrc('sm')} ${props.breakpoints[1]}w,
            ${getSrc('md')} ${props.breakpoints[2]}w,
            ${getSrc('lg')} ${props.breakpoints[3]}w,
            ${getSrc('xl')} ${props.breakpoints[4]}w`
  }
}

const getSizes = () => {
  if (props.breakpoints && props.breakpoints.length > 0) {
    return `
      (min-width: 1362px) ${props.breakpoints[4]}px,
      (min-width: 1024px) ${props.breakpoints[3]}px, 
      (min-width: 800px) ${props.breakpoints[2]}px,
      (min-width: 600px) ${props.breakpoints[1]}px,
      (max-width: 427px) ${props.breakpoints[0]}px,
      ${props.breakpoints[0]}px
    `
  }
}
</script>

<style lang="scss" scoped>
.img-element {
  padding-bottom: 0;

  &__inner {
    min-height: auto;
  }

  img {
    max-width: 100%;
    display: block;
    margin: 0 auto 24px auto;
    min-height: 100px;
    width: auto;
  }
}
</style>
